<template>
    <div>

        <nav id="sidebar" class="d-flex flex-column">
            <div class="sidebar-header justify-content-center d-flex p-4">
                <b-img fluid :src="require('@/assets/img/bb-logo-white.svg')" class="logo"></b-img>
            </div>
            <ul class="list-unstyled mt-4" ref="sidebar" v-if="user">
                <template v-for="(item, index) in navItems" v-if="item.admin ? user.admin : true">
                    <div v-if="item.separator" class="separator" :key="'separator' + index"></div>
                    <li v-else class="sidebar-link" :key="item.title">
                        <div>
                            <router-link :to="item.href"
                                         v-b-toggle="'collapse' + item.title">
                                {{ item.title }}
                            </router-link>
                        </div>
                    </li>
                </template>
            </ul>

            <div v-b-modal.logoutModal class="logout">
                <div>Logout</div>
            </div>
        </nav>
        <b-modal centered
                 id="logoutModal"
                 title="Confirm"
                 @ok="logout"
                 header-bg-variant="dark"
                 header-text-variant="white"
                 body-bg-variant="dark"
                 body-text-variant="white"
                 footer-bg-variant="dark"
                 footer-text-variant="white"
                 ok-variant="danger">
            <p class="my-2">Log out?</p>
        </b-modal>

    </div>
</template>

<script>
    export default {
        name: 'sidebar',
        data() {
            return {
                navItems: [
                    {
                        title: "Hub",
                        href: "/hub",
                    },
                    {
                        title: "Demo",
                        href: "/demo",
                    },
                    {
                        separator: true
                    },
                    {
                        title: "Companies",
                        href: "/companies",
                        admin: true
                    },
                    {
                        title: "Users",
                        href: "/users",
                        admin: true
                    },
                    {
                        title: "Adverts",
                        href: "/adverts",
                    },
                    {
                        title: "Clients",
                        href: "/clients",
                    },
                    /*{
                        title: "Finances",
                        href: "/finances",
                    },*/
                    {
                        title: "Android App",
                        href: "/android",
                        admin: true
                    },
                    {
                        separator: true
                    },

                ]
            }
        },
        computed: {
            user() {
                return this.$store.getters.getUser
            }
        },
        methods: {
            logout () {
                adamApi.post(api.logout).then(response => {
                    if (response.status === 200) {
                        this.$cookie.delete('api_token');
                        this.$router.push('/auth/login');
                    }
                })
            }
        },
        mounted() {
            this.$store.dispatch('getUser');
        }
    }
</script>

<style lang="scss">

    .logo {
        max-height: 56px
    }


    #sidebar {
        background: $bb-purple;
        width: 280px;
        min-width: 280px;
        height: 100vh;
        position: fixed;
        z-index: 999;
        color: #FFF !important;
        transition: all 0.3s;
        .sidebar-link {
            margin: 8px 0;
            > div {
                text-align: left;
                padding: 8px 30px;
                a {
                    color: #FFF !important;
                }
                a:hover {
                    text-decoration: none;
                }
            }
            a {
                transition: .3s;
            }
            a.active {
                font-size: 1.1rem;
                font-weight: 700;
                text-decoration: none;
            }
            &:hover {
                cursor: pointer;
                //font-size: 1.1rem;
                font-weight: 700;
            }
        }

    }

    .logout {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        flex: 1;
        margin: 16px 0;
        > div {
            &:hover {
                cursor: pointer;
                font-size: 1.1rem;
                font-weight: 700;
            }
        }
    }

    .sidebar-header {
        z-index: 2;
        background: $bb-purple;
        min-height: 50px;
        padding: 8px;
    }

    .separator {
        margin: 24px 0;
    }

</style>

